import { render } from "./TableAdList.vue?vue&type=template&id=1ba183a7&scoped=true"
import script from "./TableAdList.vue?vue&type=script&lang=js"
export * from "./TableAdList.vue?vue&type=script&lang=js"

import "./TableAdList.vue?vue&type=style&index=0&id=1ba183a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba183a7"]])

export default __exports__